









































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

import BriocheImageTag from 'frontend/components/BriocheImageTag.vue';

@Component({
  components: {
    BriocheImageTag,
  },
  computed: {
    ...mapState('categorizedCourses', {
      categorizedCourses: ({ items }: { items: object[] }) => items,
    }),
  },
})
export default class CourseListing extends Vue {
  private expanded: boolean = false;

  private toggleExpanded() {
    this.expanded = !this.expanded;
  }
}
